/**
 * Generate a GUID (Globally Unique Identifier)
 * @returns {string} A GUID in the format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export function generateGUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Generate multiple GUIDs
 * @param {number} count - Number of GUIDs to generate
 * @returns {string[]} Array of GUIDs
 */
export function generateMultipleGUIDs(count) {
  return Array.from({ length: count }, () => generateGUID());
}
